import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as artistsActions from '../../store/actions/artistsActions'
import * as evenimentsActions from '../../store/actions/evenimentsActions'
import { Container, Grid, GridCol } from '../common/Grid'
import { Panel } from '../common/Panel'
import { Button } from '../common/Form'
import { Eveniments } from '../Eveniments'
import './EvenimentsView.css'

import Moment from 'react-moment'
import moment from 'moment'

class EvenimentsView extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            artistId: 'default',
            placeId: 'default',
            startdate: moment().format(),
            enddate: moment().add(1, 'days').format()
        }

        this.onDatePick = this.onDatePick.bind(this)
        this.onChangeArtist = this.onChangeArtist.bind(this)
        this.onChangePlace = this.onChangePlace.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.onKeyPress = this.onKeyPress.bind(this)
    }

    componentDidMount() {
        window.addEventListener('keypress', this.onKeyPress, false)
    }

    componentWillUnmount() {
        window.removeEventListener('keypress', this.onKeyPress, false)
    }

    get currentArtist() {
        return this.state.artistId !== 'default'
            ? this.props.artists.find(item => item.id === this.state.artistId)
            : null
    }

    get currentPlace() {
        return this.state.placeId !== 'default'
            ? this.props.places.find(item => item.id === this.state.placeId)
            : null
    }

    onKeyPress(e) {
        if(e.keyCode === 13) {
            this.onSubmit(e)
        }
    }

    onDatePick(date) {
        let startdate = moment(date.toISOString()).format()
        let enddate = moment(date.toISOString()).add(1, 'days').format()

        this.setState({ startdate, enddate })
    }

    onChangeArtist(e) {
        this.setState({ artistId: e.target.value })
    }

    onChangePlace(e) {
        this.setState({ placeId: e.target.value })
    }

    onSubmit(e) {
        e.preventDefault()

        if(this.state.artistId !== 'default') {
            this.props.evenimentsActions.add(this.state)
        }
    }

    get filterResults() {
        return this.state.artistId !== 'default'
            ? this.state.placeId !== 'default'
                ? this.props.eveniments.filter(item => item.artistId === this.state.artistId && item.placeId === this.state.placeId)
                : this.props.eveniments.filter(item => item.artistId === this.state.artistId)
            : this.state.placeId !== 'default'
                ? this.props.eveniments.filter(item => item.placeId === this.state.placeId)
                : this.props.eveniments
    }

    render() {
        return (
            <Container className="eveniments-view">
                <Panel title="Evenimente">
                    <Grid>
                        <GridCol className="_left">
                            <Eveniments.AddForm
                                {...this.state}
                                eveniments={this.filterResults}
                                artists={this.props.artists}
                                places={this.props.places}
                                onDatePick={this.onDatePick}
                                onChangeArtist={this.onChangeArtist}
                                onChangePlace={this.onChangePlace}
                                onSubmit={this.onSubmit} />
                        </GridCol>
                        <GridCol className="_right">
                            <div className="message">
                                <i className="material-icons">add_circle</i>
                                <p style={{ flexGrow: '1' }}>
                                    <span>Adauga un eveniment</span>
                                    {this.currentArtist && <span> pentru <b>{this.currentArtist.name}</b></span> }
                                    {this.currentPlace && <span> in <b>{this.currentPlace.name}</b></span> }
                                    {this.state.startdate && <span> pe data de <b><Moment format="DD MMMM YYYY" date={this.state.startdate} /></b></span> }
                                </p>
                                <Button label="Adauga" onClick={this.onSubmit} />
                            </div>

                        {this.filterResults.length > 0 &&
                            <Eveniments.List
                                eveniments={this.filterResults}
                                artists={this.props.artists}
                                places={this.props.places} />
                        }

                        {this.filterResults.length === 0 &&
                            <div className="message is-outline">
                                <i className="material-icons">info_outline</i>
                                <p>Niciun eveniment adaugat</p>
                            </div>
                        }
                        </GridCol>
                    </Grid>
                </Panel>
            </Container>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        artists: state.artists.artists,
        eveniments: state.eveniments.eveniments, 
        places: state.places.places
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        artistsActions: bindActionCreators(artistsActions, dispatch),
        evenimentsActions: bindActionCreators(evenimentsActions, dispatch)
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(EvenimentsView))


// WEBPACK FOOTER //
// ./src/components/views/EvenimentsView.js